<template>
  <div class="gsxwBox">

    <div class="gsxwnei">
      <div class="gsxwHeader">
        <div class="gsxw_left">{{itemData.gsxwTitle}}</div>
        <div class="gsxw_right" @click="gsxwCK">
          <div class="gsxw_text_dd_1">{{itemData.gsxwMore}}</div>
          <div ><i class="el-icon-right"></i></div>
        </div>
      </div>
    <div class="contentBox">
      <div class="itemBox" v-for="item in itemData.gsxwItem" v-on:mouseenter="mouseeon(item.indexPath)" :style="{backgroundColor:item.backcolor}">
        <div class="gsxw_item_img">
<!--          <el-image class="ttyy"
            style="width: 376px; height: 284px"
            :src="item.imgUrl"
            :fit="contain"></el-image>-->
          <img :src="item.imgUrl" alt="" class="ttyy">
        </div>
        <div class="gsxw_item_p1">
          {{item.text1}}
        </div>
        <el-divider></el-divider>
        <div class="gsxw_item_p2">
          {{item.text2}}
        </div>
        <div class="gsxw_item_p3" @click="gsxwToItem(item.indexPath)">
          <div class="gsxw_item_p3_1">
            {{item.text3}}
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<style scoped>
.gsxw_item_img{
  width: 100%;
  aspect-ratio: 376/284;
  /*height: 360px;*/
}
.ttyy{
  width: 100%;
  border-radius: 10px;
}
.gsxw_item_p3_1{
  background-color: #5daf34;
  width: 123px;
  height: 36px;
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gsxw_item_p3{
  display: flex;
  justify-content: center;
  margin-top: 20px;
  cursor: pointer;
}
.gsxw_item_p2{
  font-family: SourceHanSansCN;
  font-size: 24px;
  color: #333333;
  text-align: center;
}
.gsxw_item_p1{
  font-family: SourceHanSansCN;
  font-size: 16px;
  color: #666666;
  text-align: center;
  margin-top: 15px;
}
.itemBox{
  width: 31.97%;
  margin-right: 15px;
  aspect-ratio: 376/530;
  border-bottom: 1px solid #666666;
  border-radius: 10px;
}
.gsxwnei{
  width: 67.25%;
}
.contentBox{
  width: 100%;
  display: flex;
}
.gsxw_text_dd_1{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
}
.gsxw_right{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #8c939d;
  letter-spacing: 0;
  text-align: justify;
  display: flex;
  cursor: pointer;
}
.gsxw_left{
  font-family: SourceHanSansCN;
  font-size: 30px;
  color: #333333;
  letter-spacing: 0.64px;
  text-align: justify;
}
.gsxwHeader{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px auto 30px;
}
.gsxwBox{
  width: 100%;
  /*height: 710px;*/
  background: #FFFFFF;
  padding: 0 0 100px 0px;
  margin: 0 auto;
  display: flex;
  justify-content: center;

}


</style>
<script>
import {Data} from "../js/image/gsxw";

export default {
  name: "gsxw",
  data() {
    return {
      dataAll: Data,
      itemData: {},

    }
  },
  mounted() {
    let that = this;

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      if(that.$parent.$parent.message == itemData.type){
        that.itemData = itemData;
        break;
      }
    }
  },
  methods:{
    gsxwCK(){
      this.$router.push('/news2');
    },
    gsxwToItem(path){
      this.$router.push('/newsItem?index='+path);
    },
    mouseeon(path){
      let that = this;
      for(let index in that.gsxwItem){
        let itemData = that.gsxwItem[index];
        if(path == itemData.indexPath){
          itemData.backcolor = "#F3F4F8"
        } else {
          itemData.backcolor = "#FFFFFF"
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/image/gsxw.vue